"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");


































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], imageSrcList: [], searchData: { sn: '', otaVersion: '', startTime: '', endTime: '', reportTime: [], upgradeStatus: '', createStart: '', createEnd: '', type: '2', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'sn', label: '设备序列号', isShow: true }, { prop: 'otaVersion', label: '版本', isShow: true }, { prop: 'upgradeStatus', label: '状态', formatter: _formatter.xunfeiStatusFormatter, isShow: true }, { prop: 'createTime', label: '上报时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;var params = Object.assign({}, self.searchData);delete params['reportTime'];self.getData('/api/faOtaUpgradeLog', params, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.sn = '';this.searchData.otaVersion = '';this.searchData.upgradeStatus = '';this.searchData.startTime = '';this.searchData.endTime = '';this.searchData.reportTime = [];this.init();}, searchFun: function searchFun() {// 搜索事件
      if (this.searchData.reportTime.length > 1) {this.searchData.startTime = this.searchData.reportTime[0];this.searchData.endTime = this.searchData.reportTime[1];}this.searchData.page = 1;if (this.searchData.startTime && this.searchData.startTime.split(' ').length < 2) {this.searchData.startTime += ' 00:00:00';}if (this.searchData.endTime) {var endTime = this.searchData.endTime;if (endTime.split(' ').length < 2) {endTime = endTime + ' 23:59:59';this.searchData.endTime = endTime;}}console.log(this.searchData);this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();
    } } };exports.default = _default;